<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pWkcZr/tc-custom/9783965371743.jpg" alt="This image is the cover for the book The Coxswain's Bride also Jack Frost and Sons and A Double Rescue, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Coxswain's Bride also Jack Frost and Sons and A Double Rescue, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>The book contains three stories. The first one, The Coxswain's Bride is the longest and the other two are quite short. Jack Frost is an interesting story personifying the cold winter wind. The Double Rescue is a bit fantastical, but not totally impossible. (Amazon)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        R. M. Ballantyne
      </h2>
      
      <p class="authorDescription body article">Robert Michael Ballantyne (24 April 1825 – 8 February 1894) was a Scottish author of juvenile fiction who wrote more than 100 books. He was also an accomplished artist, and exhibited some of his water-colours at the Royal Scottish Academy. (Wikipedia)</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      otbebookpublishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fe99f21a